import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { Eye, EyeOff } from "lucide-react";

import axiosInstance from "../../axiosInterceptor";
import { EmailConfigSchema } from "../../Validation/Validation";

const EmailConfiguration = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      host: "",
      port: "",
    },
    validationSchema: EmailConfigSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        await axiosInstance.post(
          "emailconfiguration/email-configuration",
          values
        );

        toast.success("Email configuration updated successfully!");
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
          "Failed to update email configuration"
        );
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(
        "emailconfiguration/email-configuration"
      );

      if (response.data?.data) {
        const { _id, createdAt, updatedAt, __v, ...cleanData } =
          response.data.data;

        formik.setValues(cleanData);
      }
    } catch (error) {
      toast.error("Failed to fetch email configuration");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Email Configuration</h3>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Email</label>

                <input
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  className={`form-control border border-dark ${formik.touched.email && formik.errors.email
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />

                {formik.touched.email && formik.errors.email && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.email}
                  </div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label>App Password</label>

                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter app password"
                    className={`form-control border border-dark ${formik.touched.password &&
                      formik.errors.password
                      ? "is-invalid"
                      : ""
                      }`}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />

                  <span
                    className="input-group-text"
                    style={{
                      cursor: "pointer",
                      background: "#0d1253",
                      color: "#fff",
                    }}
                    onClick={() =>
                      setShowPassword(!showPassword)
                    }
                  >
                    {showPassword ? (
                      <Eye size={18} />
                    ) : (
                      <EyeOff size={18} />
                    )}
                  </span>
                </div>

                {formik.touched.password &&
                  formik.errors.password && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.password}
                    </div>
                  )}
              </div>

              <div className="col-md-6 mb-3">
                <label>SMTP Host</label>

                <input
                  type="text"
                  name="host"
                  placeholder="Enter SMTP host"
                  className={`form-control border border-dark ${formik.touched.host && formik.errors.host
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.host}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />

                {formik.touched.host &&
                  formik.errors.host && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.host}
                    </div>
                  )}
              </div>

              <div className="col-md-6 mb-3">
                <label>Port</label>

                <input
                  type="number"
                  name="port"
                  placeholder="Enter port"
                  className={`form-control border border-dark ${formik.touched.port && formik.errors.port
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.port}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />

                {formik.touched.port &&
                  formik.errors.port && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.port}
                    </div>
                  )}
              </div>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
                onClick={() =>
                  formik.setTouched({
                    email: true,
                    password: true,
                    host: true,
                    port: true,
                  })
                }
              >
                {loading ? "Processing..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailConfiguration;